import {
  SmartTable,
  SmartTableColumn,
  SmartTableProps,
} from '@toggle/design-system';
import { MappedEntity } from '@toggle/toggle';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { AssetLogoContainer } from '~/components/asset-logo-container/AssetLogoContainer';
import { TruncateTooltip } from '~/components/truncate-tooltip/TruncateTooltip';
import { MAX_TICKER_DISPLAY_LENGTH } from '~/stores/use-watchlist/constants';

import * as S from './WatchlistMessageTable.styles';

export interface WatchlistMessageTableProps {
  entities: MappedEntity[];
  renderActionColumn?: SmartTableProps<MappedEntity>['renderActionColumn'];
  name?: string;
}

export const WatchlistMessageTable: FC<WatchlistMessageTableProps> = ({
  entities,
  renderActionColumn,
  name,
}) => {
  const { t } = useTranslation(['watchlistManager', 'analyze']);

  const columns: SmartTableColumn<MappedEntity>[] = [
    {
      label: t('watchlistManager:tickerColumnLabel'),
      key: 'ticker',
      render: (_, entity) => (
        <S.TickerCell>
          {entity && <AssetLogoContainer entity={entity} size={24} />}
          <S.Ticker>
            <TruncateTooltip
              text={entity.formattedTicker}
              atLength={MAX_TICKER_DISPLAY_LENGTH}
            />
          </S.Ticker>
        </S.TickerCell>
      ),
    },
    {
      label: t('watchlistManager:nameColumnLabel'),
      key: 'name',
      render: value => <S.AssetName>{value}</S.AssetName>,
    },
    {
      label: t('watchlistManager:typeColumnLabel'),
      key: 'sub_class',
      render: subClass =>
        /* i18next-extract-disable-next-line */
        subClass ? t(`analyze:assetSubClass.${subClass}`) : '-',
    },
  ];

  return (
    <div data-testid="watchlist-message-table">
      {name && <S.Name>{name}</S.Name>}
      <SmartTable
        columns={columns}
        data={entities}
        renderActionColumn={renderActionColumn}
      />
    </div>
  );
};
